module.exports = __webpack_public_path__ + "static/media/Minesweeper.b355b67d.png";